// mixin.js
import { ProductUIInfo, ProductUIInfoFuse } from '@/store/modules/product';
import { CertificateInfo } from '@luxtag/papybase';
import { Component, Vue } from 'vue-property-decorator';

// You can declare a mixin as the same style as components.
@Component
export default class SearchedProductMixin extends Vue {
    public translateProductToProductUI(productInfo: CertificateInfo): ProductUIInfo {
        let payload: any = {
            Model: '',
            'Serial No.': '',
        };

        if (productInfo.payload) {
            productInfo.payload = productInfo.payload.replace(/uploads/g, 'files');
            payload = JSON.parse(productInfo.payload);
        }

        return {
            id: productInfo.id,
            name: payload.Model,
            serialNumber: payload['Serial No.'],
            time: productInfo.createdAt,
            date: productInfo.createdAt,
            owner: productInfo.merchant,
            address: productInfo.address,
            privateKey: productInfo.private_key,
            publicKey: productInfo.public_key,
            imgs: (payload.img) ? [payload.img] : [],
            img: (payload.img) ? payload.img : '',
            // UUID: productInfo.id,
            // printStatus: ,
            details: payload,
            status: 'green',
        };
    }

    // public translateProductToProductUI(productInfo: CertificateInfo): ProductUIInfo {
    //     let payload: any = {
    //         Model: '',
    //         'Serial No.': '',
    //     };

    //     if (productInfo.payload) {
    //         productInfo.payload = productInfo.payload.replace(/uploads/g, 'files');
    //         payload = JSON.parse(productInfo.payload);
    //     }

    //     return {
    //         id: productInfo.id,
    //         name: payload.Model,
    //         serialNumber: payload['Serial No.'],
    //         time: productInfo.createdAt,
    //         date: productInfo.createdAt,
    //         owner: productInfo.merchant,
    //         address: productInfo.address,
    //         privateKey: productInfo.private_key,
    //         publicKey: productInfo.public_key,
    //         imgs: (payload.imgs) ? payload.imgs : [],
    //         // UUID: productInfo.id,
    //         // printStatus: ,
    //         details: payload.data,
    //         status: 'green',
    //     };
    // }

    public translateProductToProductUIFuse(productInfo: CertificateInfo): ProductUIInfoFuse {
        return {
            item: this.translateProductToProductUI(productInfo),
            matches: [],
            score: 1,
        };
    }


    get fuseJSOptions() {
        return {
            shouldSort: true,
            includeMatches: true,
            threshold: 0.2,
            location: 0,
            distance: 100,
            maxPatternLength: 32,
            minMatchCharLength: 2,
            keys: [
                'privateKey',
                'publicKey',
                'address',
                'serialNumber',
                'name',
            ],
        };
    }
}
